<template>
    <div id="apf">
        <div v-if="!isSubmitted && !isDraft" class="container">
          <h4 class="text-red">Online Withdrawal Form</h4>
	        <div class="row mt-3">
                <div class="w-100" :class="{ 'form-group--error': $v.state.StudentNo.$error }">
                    <K2Row>
                        <K2Row align="center" class="me-2"
                               style="width: 70%; padding: 0 15px; margin-bottom: 10px; background: white; border: 1px solid #eee; border-radius: 11px;">
                            <div>
                                <img src="../../assets/momentGraduationCap.png"
                                     style="width: 20px; vertical-align: sub; margin-right: 5px;"/>
                            </div>
                            <strong>* Student No: </strong>
                            <div style="display: inline-block; margin-left: 10px; flex-grow: 1">
                                <input class="form-control m-0 ddl-sch-opt" type="text" v-model="state.StudentNo"
                                       placeholder="Please insert student no"/>
                            </div>
                        </K2Row>
                        <K2Button @onclick="handleStudentInfo()" v-if="!this.$route.query.studentID">Search</K2Button>
                    </K2Row>

                    <div class="error requiredFieldsMsg" v-if="!$v.state.StudentNo.required"
                         style="margin-bottom: 10px">
                        <el-alert :title="getValidationMessageFromKey('StudentID')" type="error"></el-alert>
                    </div>
                </div>
            </div>
            <div class="mt-3" v-if="state.Full_Name">
              <WithdrawalFormLogo :current-school="currentSchool" :isInternationalSchool="isInternationalSchool" />
              <!--student information: start-->
              <WdfStudentInformation
                :hideChildName="true"
                :state="state" @change="state.StudentPass = $event"
                @StudentName="handleInputChange('StudentName',$event)"
                :isInternationalSchool="isInternationalSchool" />
              <div :class="{ 'form-group--error': $v.state.StudentName.$error }">
                <div class="error requiredFieldsMsg" v-if="!$v.state.StudentName.required"
                     style="margin-bottom: 10px">
                  <el-alert :title="getValidationMessageFromKey('StudentName')" type="error"></el-alert>
                </div>
              </div>
              <div :class="{ 'form-group--error': $v.state.StudentPass.$error }">
                <div class="error requiredFieldsMsg" v-if="!$v.state.StudentPass.required"
                     style="margin-bottom: 10px">
                  <el-alert :title="getValidationMessageFromKey('StudentPass')" type="error"></el-alert>
                </div>
              </div>
                <!--student information: end-->


                <div class="saf-student-details-cotainer mt-3" style="position: relative">
                    <div style="margin-bottom: 20px">
                        <label class="common-label-title">Student Withdraw Form</label>
                        <small>(Please provide a written notice to the Parent Liaison Office of any changes to the
                            information provided in this form.)
                        </small>
                    </div>
                    <!--stud Withdraw Form: start-->
                    <div :class="{ 'form-group--error': $v.state.StudentPass.$error }">
                        <OnlineStudentWithdrawForm :isHideButton="true"
                                                   :withdrawReasonList="withdrawReasonList"
                                                   :withdrawalDateRemarks="'(last day of attendance in school)'"
                                                   @school="handleInputChange('School',$event)"
                                                   @schoolText="handleInputChange('SchoolDetails',$event)"
                                                   @SchoolType="handleInputChange('SchoolType', $event)"
                                                   @reason1Text="handleInputChange('Reason1Text',$event)"
                                                   @reason1="handleInputChange('Reason1',$event)"
                                                   @CountryName="handleInputChange('CountryName', $event)"
                                                   @Improvement="handleInputChange('Improvement', $event)"
                                                   @main-reason="handleInputChange('MainReason',$event)"
                                                   @date="handleWithdrawalDateChange($event)"
                        />
                    </div>
                    <div :class="{ 'form-group--error': $v.state.Date.$error }" class="error requiredFieldsMsg"
                         v-if="!$v.state.Date.required" style="margin-bottom: 10px">
                        <el-alert :title="getValidationMessageFromKey('Date')" type="error"></el-alert>
                    </div>
                  <div :class="{ 'form-group--error': $v.state.MainReason.$error }" class="error requiredFieldsMsg"
                       v-if="!$v.state.MainReason.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('MainReason')" type="error"></el-alert>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.Reason1Text.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.Reason1Text.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('Reason1Text')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.Reason1.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.Reason1.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('Reason1')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.CountryName.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.CountryName.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('CountryName')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.SchoolType.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.SchoolType.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('SchoolType')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.School.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.School.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('School')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.SchoolDetails.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.SchoolDetails.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('SchoolDetails')"
                                type="error"></el-alert>
                    </div>
                  </div>
                  <div :class="{ 'form-group--error': $v.state.Improvement.$error }">
                    <div class="error requiredFieldsMsg" v-if="!$v.state.Improvement.required"
                         style="margin-bottom: 10px">
                      <el-alert :title="getValidationMessageFromKey('Improvement')"
                                type="error"></el-alert>
                    </div>
                  </div>
                    <!--stud Withdraw Form: end-->

                    <!--stud pass Information: start-->
                    <WdfStudentPassInformation :isInternationalSchool="isInternationalSchool"/>
                    <!--stud pass Information: end-->

                    <div style="margin-bottom: 20px" class="mt-5">
                        <label class="common-label-title">Bank Account Details </label>
                    </div>
                    <div class="mb-3"
                         style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem;">
                        <ApfBasicInput label="Name of Account Holder" :validator="$v" name="BankAccountHolder" :hideValidator="!isPreschool">
                            <input class="form-control" type="text" v-model="state.BankAccountHolder"/>
                        </ApfBasicInput>
                        <ApfBasicInput label="Name of Bank" :validator="$v" name="BankName">
                            <input class="form-control" type="text" v-model="state.BankName"/>
                        </ApfBasicInput>
                        <ApfBasicInput label="Swift Code" :validator="$v" name="BankCode">
                            <input class="form-control" type="text" v-model="state.BankCode"/>
                        </ApfBasicInput>
                        <ApfBasicInput label="Account Number" :validator="$v" name="BankAccount">
                            <input class="form-control" type="text" v-model="state.BankAccount"/>
                        </ApfBasicInput>
                        <ApfBasicInput label="Email Address" :validator="$v" name="Email">
                            <input class="form-control" type="text" v-model="state.Email"/>
                        </ApfBasicInput>
                        <ApfBasicInput label="Contact Number" :validator="$v" name="Contact">
                            <input class="form-control" type="text" v-model="state.Contact"/>
                        </ApfBasicInput>
                    </div>

                    <p v-if="isInternationalSchool">By signing below, I certify that the above information
                        is true. </p>
                    <!--<p v-else>*If the deposit was paid using a Child Development Account (CDA), any balance-->
                        <!--that is refundable from the deposit will be credited back into the relevant CDA.-->
                        <!--<br/><br/>By signing below, I certify that the above information is true. </p>-->
                    <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem;">
                        <ApfBasicInput label="Name of Parent" name="ParentName" :validator="$v">
                            <input class="form-control" type="text" v-model="state.ParentName"/>
                        </ApfBasicInput>

                        <ApfBasicInput name="ParentSignature" label="Signature" :validator="$v">
                            <div v-on:click="$bvModal.show('signatureModal')" class="signature-pad">
                                <img v-if="state.ParentSignature" :src="state.ParentSignature" type="file"
                                     class="imgParentSignature"/>
                            </div>
                        </ApfBasicInput>
                    </div>
                    <hr/>
                </div>

                <div style="margin: 20px 0 0 0; background: #eeeeee; padding: 10px; display: flex; justify-content: space-between; flex-wrap: wrap;">
                    <button class="btn btn-success" @click="validationForm()">
                        Submit Application
                    </button>
                    <!--<div style="display:flex; gap: 10px; margin-left: auto;">-->
                    <!--<button class="btn btn-primary"-->
                    <!--@click="saveDraft()">-->
                    <!--Save As Draft-->
                    <!--</button>-->
                    <!--</div>-->
                </div>
                <div v-if="validationErrors.length > 0" style="padding: 0.5rem 0;">
                    <div class="el-alert el-alert--error is-light" style="display: block;">
                        <div style="font-weight: bold;">Please fill in the following required fields:</div>
                        <ol class="el-alert__content" style="padding-left: 2rem; padding-bottom: 0;">
                            <li v-for="[errKey] in validationErrors" :key="errKey">{{
                                getValidationMessageFromKey(errKey) }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <WdfAfterSubmitMessage group="EH" v-else-if="isSubmitted" :currentSchool="currentSchool"  :isInternationalSchool="isInternationalSchool"/>
        <ApfSignaturePadModal @save="saveSignature($event)"/>
    </div>
</template>

<script>
    import DataSource from "../../data/datasource";
    import { lang } from "@/locale";
    import ApfBasicInput from "./component/WdfBasicInput";
    import { preValidations, getValidationMessageFromKey, ehValidations } from "./component/data.js";
    import ApfSignaturePadModal from "@/pages/application/components/ApfSignaturePadModal";
    import WdfStudentInformation from "./text/WdfStudentInformation";
    import StudentWithdrawForm from "../../components/StudentWithdrawForm";
    import WdfStudentPassInformation from "./text/WdfStudentPassInformation";
    import { constDateFormat, getFormatDate } from "@/helper/utily";
    import { checkIsPreschool, isInternational } from "@/helper/util_custom";

    import K2Button from "../../uiComponents/k2Button/k2Button";
    import K2Row from "../../uiComponents/k2Row/k2Row";
    import assets from "../../assets/assets";
    import WdfAfterSubmitMessage from "./text/WdfAfterSubmitMessage";
    import { WithdrawReason } from "./component/withdrawReason";
    import OnlineStudentWithdrawForm from "./component/onlineStudentWithdrawalForm.vue";
    import WithdrawalFormLogo from "@/pages/withdrawal/component/withdrawLogo.vue";
    import { orchardValidations, schools } from "@/pages/application/data";

    export default {
		    validations() {
					if(this.isPreschool){
						return preValidations;
					}else{
						return ehValidations;
					}
		    },
        name: "onlineWithdrawalForm",
        components: {
          WithdrawalFormLogo,
          OnlineStudentWithdrawForm,
            WdfAfterSubmitMessage,
            K2Row,
            K2Button,
            WdfStudentPassInformation,
            WdfStudentInformation,
            ApfSignaturePadModal,
            ApfBasicInput
        },
        data() {
            return {
                assets: assets,
                state: {
                  StudentID: null,
                  StudentNo: null,
                  Full_Name: null,
                  CLS_ClassName: null,
                  CRS_Level: null,
                  DateOfNotice: null,
                  StudentPass: null,
                  SchoolType: null,
                  School: null,
                  Reason1Text: null,
                  Reason1: null,
                  SchoolDetails: null,
                  BankAccountHolder: null,
                  BankName: null,
                  BankCode: null,
                  BankAccount: null,
                  Email: null,
                  Contact: null,
                },
                isSubmitted: false,
                isDraft: false,
                studID: "",
                schoolList: null,
                isInternationalSchool: "",
                currentSchool:"",
	              isPreschool: false,
                withdrawReasonList : WithdrawReason
            };
        },
        props: [],
        async mounted() {
            this.schoolList = (await DataSource.shared.getSchoolDropdownList("UTY201300000061"))?.Table;
            if(this.$route.query.studentID){
                this.state.StudentNo = atob(this.$route.query.studentID);
                await this.handleStudentInfo();
            }
        },
        methods: {
            lang,
            getValidationMessageFromKey,
            handleInputChange(name, val) {
                this.$set(this.state, name, val);
            },
          async handleWithdrawalDateChange(val) {
            await this.handleStudentInfo(getFormatDate(val,constDateFormat.apiDate,"DD/MM/YYYY"))
            this.handleInputChange('Date',val)
          },
            async handleStudentInfo(date) {
                const resp = await DataSource.shared.getStudentforWithdrawal(this.state?.StudentNo, date);
                if (resp) {
                    if (resp?.code === "2" || resp?.code === "99") {
                        this.$notify({
                            title: lang("Error"),
                            message: lang("Student not available"),
                            type: "error"
                        });

                        return;
                    }
										this.isPreschool = checkIsPreschool(resp?.[0]?.School_ID);
                    let currentSchool = this.schoolList?.find(d => d.SchoolID === resp?.[0]?.School_ID);
                    this.currentSchool = currentSchool;
                    this.isInternationalSchool = isInternational(currentSchool?.SchoolName);
                    this.state.Full_Name = resp?.[0]?.Full_Name + " " + resp?.[0]?.Last_name;
                    this.state.StudentID = resp?.[0]?.Student_ID;
                    this.state.CLS_ClassName = resp?.[0]?.CLS_ClassName;
                    this.state.CRS_Level = resp?.[0]?.CRS_Level;
                    this.state.DateOfNotice = getFormatDate(new Date());
                    console.log(this.state, "state");
                }
            },
            async saveWithdrawalForm() {
                try {
                  this.$vs.loading();

                    const res = await DataSource.shared.saveWithdrawalForm(this.state);
                    if (res) {
                        const code = Number(res?.code || 0);
                        if (code !== 1) {
                            this.flashError(res?.message || "Unknown Error! Please contact support.");
                        }
                        this.$notify({
                            title: "Success",
                            message: "Records Successfully Saved",
                            type: "success"
                        });
                        this.isSubmitted = true;
                    }
                }catch (e){
                  console.log(e,"saveWithdrawalForm err")
                }
              this.$vs.loading.close();

            },

            async validationForm() {
                console.log(this.state, "state");
                this.$v.$touch();
                if (this.$v.$error) {
                    return this.flashError("Please fill in all * fields");
                }
                window.scrollTo(0, 0);
                await this.saveWithdrawalForm();
            },

            async saveSignature(data) {
                this.signatureType = "si";
                this.$set(this.state, "ParentSignature", data);
                this.daSignature = data;
            },

            flashError(msg) {
                return this.$notify.error({ title: "Error", message: msg });
            }
        },

        computed: {
            validationErrors() {
                return Object.entries(this.$v.state).filter(([key, attr]) => attr?.$anyError);
            }
        }
    };
</script>

<style>
    @import './withdrawalForm.css';
</style>
